export default "__VITE_ASSET__fcc38db4__"